import { TaskDetail } from '../models/insights';
import { Job, JobPhase } from '../models/jobs';

const convertTaskToJob = (task: TaskDetail) => {
  return {
    _id: task.task_id,
    agent_id: task.agent_id,
    due_time: task.due_time,
    description: task.task_description,
    destination: {
      name: task.dest_name,
      lat: task.dest_lat,
      lng: task.dest_lng
    },
    phase: task.last_phase,
    operation: {
      task_id: task.task_id,
      start_time: +task.time_started,
      invite_code: null,
      invite_url: '',
    },
    org_id: task.org_id,
    metadata: task.metadata,
    start_time: +task.time_started,
    removed: false,
    completed: task.last_phase === JobPhase.Completed,
    invite_code: null,
    created_time: +task.task_created_time,
    completed_time: +task.completed_time,
    arrived_time: +task.time_arrived,
    recipients: task?.recipients?.filter?.(r => r.notify),
    images: task.images,
    aggregations: {
      task_id: task.task_id,
      location_shared: task.location_shared,
      distance_traveled: task.distance_traveled,
    },
    feedback: {
      rating: task.feedback_rating ,
      comment: task.feedback_comment
    }
  } as Job;
};

export default convertTaskToJob;
